import './covid19/main-covid.js';
import './covid19/date-picker';

const dotsSection = document.querySelector('.dots-section');
const inputFilter = document.querySelector(
  '.user-inputs-wrapper .user-inputs .filters'
);
const filters = document.querySelectorAll(
  '.user-inputs-wrapper .user-inputs .filters .filter'
);
const button = document.querySelector('.user-inputs-wrapper #apply');

inputFilter.addEventListener('click', function(e) {
  let checked = false;
  for (let i = 0; i < filters.length; i++) {
    if (filters[i].querySelector('.first input').checked) {
      checked = true;
    }
  }
  if (checked) {
    if (button.classList.contains('disable')) {
      button.classList.add('enable');
      button.classList.remove('disable');
    }
  } else {
    if (button.classList.contains('enable')) {
      button.classList.remove('enable');
      button.classList.add('disable');
    }
  }
});

document.querySelector('.dot-67').classList.add('visited');
function spreadCovid(e) {
  const visited = document.querySelector('.visited');
  const { top, left } = visited.getBoundingClientRect();
  visited.style.marginTop = e.y + 'px';
  visited.style.marginLeft =
    e.x - visited.parentNode.parentNode.offsetLeft + 'px';

  if (e.target.classList.contains('dot')) {
    e.target.classList.add('effected');
  }
}
window.addEventListener('mousemove', spreadCovid);

// if (window.innerWidth >= 768) {
//   setTimeout(() => {
//     document.querySelector('.inro-message').style.visibility = 'hidden';
//   }, 5000);

//   setTimeout(() => {
//     document.querySelector('.message-one').style.visibility = 'hidden';
//   }, 11000);
// } else {
//   setTimeout(() => {
//     document.querySelector('.inro-message-res').style.visibility = 'hidden';
//     dotsSection.style.display = 'block';
//   }, 7000);

//   setTimeout(() => {
//     document.querySelector('.message-one-res').style.visibility = 'hidden';
//   }, 13000);
// }

// filter logic

var activeTypes = [];
$('.js-filter').on('change', function() {
  var target = $(this);
  var type = target.data('type');
  var isSelected = target.is(':checked');
  if (!isSelected) {
    activeTypes = activeTypes.filter(key => key != type);
  } else {
    if (!activeTypes.includes(type)) {
      activeTypes.push(type);
    }
  }
});

const referenceMap = {
  2: { '1-14': '4', '15-21': '3.6', '22-24': '2.8', '25-31': '2' }, // indicates march as key
  3: { '1-14': '2', '15-30': '2.8' } // indicates april as key
};

function isValidDate(d) {
  return d instanceof Date && !isNaN(d);
}

function extractR0(date) {
  if (!isValidDate(date)) return 1;
  const month = date.getMonth();
  const monthRef = referenceMap[month];

  const dateNum = date.getDate();

  // extract the value from the map
  const matchKey = Object.keys(monthRef).find(key => {
    const range = key.split('-').map(k => parseInt(k, 10));
    const start = range[0];
    const end = range[1];

    // if not range, then exact match
    if (!end) return start === dateNum;

    return dateNum >= start && dateNum <= end;
  });

  if (!matchKey) return 1;

  return monthRef[matchKey];
}

function getValues(type, selectedDate, endDate) {
  if (!isValidDate(selectedDate) || !isValidDate(endDate)) return 0; // hanlde

  var masterTotal = 0;
  var si = 0;
  var infected = 0;

  if (type === 'red-bottom') {
    si = 4;
  }

  activeTypes.forEach(_type => {
    if (_type === 'filter-1') {
      si = si + 0.67;
    }
    if (_type === 'filter-2') {
      si = si + 0.67;
    }
    if (_type === 'filter-3') {
      si = si + 0.67;
    }
    if (_type === 'filter-4') {
      si = si + 0.67;
    }
    if (_type === 'filter-5') {
      si = si + 0.67;
    }
    if (_type === 'filter-6') {
      si = si + 0.67;
    }
  });

  var cloneDate = new Date(selectedDate);

  while (cloneDate.getTime() <= endDate.getTime()) {
    if (infected === 0) {
      cloneDate.setDate(cloneDate.getDate() + 4);
      infected = si;
    } else {
      infected = infected * extractR0(cloneDate);
    }

    // increment the days by  4
    cloneDate.setDate(cloneDate.getDate() + 4);
    masterTotal = masterTotal + infected;
  }

  return Math.round(parseInt(masterTotal, 10));
}

var positive =
  'https://twitter.com/intent/tweet?text=By%20social%20distancing%2C%20I%E2%80%99ll%20continue%20saving%20XXXXX%20people%20from%20getting%20infected%20by%20COVID-19.%20You%20should%20also%20do%20your%20bit.%20&hashtags=DistancingSavesLives%20&url=https://razorpay.com/corona-virus-simulator/';

var negative =
  'https://twitter.com/share?text=Today%20I%20learnt%20that%20I%20can%20save%20YYYYY%20people%20by%20practising%20social%20distancing.%20I%20pledge%20to%20stay%20indoors%20and%20help%20fight%20COVID-19.%20You%20should%20also%20do%20your%20bit.%20#DistancingSavesLives;url=https://razorpay.com/corona-virus-simulator&amp;via=razorpay';

var fbHref =
  'https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fbit.ly%2F3447Or5&quote=With%20social%20distancing,%20I%E2%80%99ve%20already%20stopped%20COVID-19%20from%20spreading%20to%20XXXXX%20people.%20And%20I%20pledge%20to%20continue%20the%20same%20to%20save%20YYYYY%20more.%20You%20should%20also%20do%20your%20bit%20%23DistancingSavesLives';

$('.js-apply').on('click', function() {
  // const targetDate = new Date('2020-03-14 00:00:00');
  const dateFromHtml = $('#date-picker #current-date')
    .html()
    .trim()
    .split(' ');
  var date = dateFromHtml[0].replace(/\D+/g, '');

  var months = {
    Mar: '03',
    Apr: '04'
  };
  var formattedDate = `2020/${months[dateFromHtml[1]]}/${date}`;
  var targetDate = new Date(formattedDate.replace(/-/g, '/'));

  const topNumber = getValues('top', targetDate, new Date());
  const blueBottom = getValues(
    'blue-bottom',
    targetDate,
    new Date('2020-04-30'.replace(/-/g, '/'))
  );
  const redBottom = getValues(
    'red-bottom',
    new Date(),
    new Date('2020-04-30'.replace(/-/g, '/'))
  );

  if (topNumber >= 0) {
    $('#replay .blue').show();
    $('#replay .red').hide();
  } else {
    $('#replay .red').show();
    $('#replay .blue').hide();
  }

  $('#replay #b1').html(numberWithCommas(Math.abs(topNumber)));
  $('#replay #r1').html(numberWithCommas(Math.abs(topNumber)));
  $('#replay #b2').html(numberWithCommas(Math.abs(blueBottom)));
  $('#replay #r2').html(numberWithCommas(Math.abs(redBottom)));

  $('#replay .blue .twitter').attr(
    'data-href',
    positive
      .replace('XXXXX', numberWithCommas(blueBottom))
      .replace('YYYYY', numberWithCommas(topNumber))
  );

  $('#replay .blue .facebook').attr(
    'data-href',
    fbHref
      .replace('XXXXX', numberWithCommas(topNumber))
      .replace('YYYYY', numberWithCommas(blueBottom))
  );

  $('#replay .red .twitter').attr(
    'href',
    negative.replace('YYYYY', numberWithCommas(Math.abs(topNumber)))
  );

  var progressbar = $('.progressbar')[0];
  progressbar.style.display = 'block';
  progressbar.offsetLeft;
  setTimeout(() => {
    progressbar.classList.add('active');
  }, 200);
  setTimeout(() => {
    progressbar.style.display = 'none';
    progressbar.classList.remove('active');
  }, 9700);
});

function numberWithCommas(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}
